import React from 'react';
import './AppointmentInfo.css';

const AppointmentInfo = (props) => {
  const {
    productCategory,
    duration,
    gender,
    selectedLanguage,
    nonGpProductId,
    price
  } = props;

  // console.log('Rendering AppointmentInfo with props:', props);

  // Helper function to capitalize first letter
  const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // Determine the title based on product category
  const getTitle = () => {
    if (productCategory?.product_category_id === 1) {
      return 'GP appointment';
    } else if (productCategory?.product_category_id === 2) {
      return 'Health screen';
    } else if (productCategory?.product_category_id === 3) {
      return 'Corporate appointment';
    }
    return productCategory?.title || '';
  };

  // Render GP Appointment details with styled key-value pairs
  const renderGpAppointmentDetails = () => {
    // console.log('Rendering GP Appointment details');
    
    const details = [];
    
    if (duration) {
      details.push(
        <span key="duration" className="detail-item">
          <span className="detail-key">Duration: </span>
          <span className="detail-value">{duration} minutes</span>
        </span>
      );
    }
    
    if (price) {
      details.push(
        <span key="price" className="detail-item">
          <span className="detail-key">Price: </span>
          <span className="detail-value">£ {price}</span>
        </span>
      );
    }
    
    if (gender && gender !== 'no_preference') {
      details.push(
        <span key="gender" className="detail-item">
          <span className="detail-key">Gender: </span>
          <span className="detail-value">{capitalize(gender)}</span>
        </span>
      );
    }
    
    if (selectedLanguage?.label && selectedLanguage.label !== 'English') {
      details.push(
        <span key="language" className="detail-item">
          <span className="detail-key">Language: </span>
          <span className="detail-value">{capitalize(selectedLanguage.label)}</span>
        </span>
      );
    }
    
    return (
      <div className="details-container">
        {details.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="separator"> | </span>}
            {item}
          </React.Fragment>
        ))}
      </div>
    );
  };

  // Render Health Screen details
  const renderHealthScreenDetails = () => {
    // console.log('Rendering Health Screen details');
    return (
      <div className="detail-item">
        <span className="detail-value">{nonGpProductId || ''}</span>
      </div>
    );
  };

  return (
    <div className="appointment-info">
      <div className="info-title">{getTitle()}</div>
      
      {productCategory?.product_category_id === 1 && renderGpAppointmentDetails()}
      {(productCategory?.product_category_id === 2 || productCategory?.product_category_id === 3) && renderHealthScreenDetails()}
    </div>
  );
};

export default AppointmentInfo;